import React from "react";

const Avatar = ({ user, size = "w-10 h-10", rounded = "rounded-full" }) => {
  const name = user?.name || user?.username || "Traveler";
  const initial = name[0]?.toUpperCase();

  return (
    <div
      className={`${size} ${rounded} overflow-hidden bg-[#5b6f00]/10 flex items-center justify-center`}
    >
      {user?.avatar ? (
        <img
          src={user.avatar}
          alt={name}
          className="w-full h-full object-cover"
        />
      ) : (
        <span className="font-bold text-[#5b6f00]">
          {initial}
        </span>
      )}
    </div>
  );
};

export default Avatar;